module.exports = __webpack_public_path__ + "media/images/GettyImages-1251678849-headerimage-4839d9126ab180038a0f3c0390ab0f6c.jpg";